import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/components/common/SafeIcon';

const { FiCheckCircle, FiArrowRight } = FiIcons;

export default function PaymentSuccess() {
  const navigate = useNavigate();

  useEffect(() => {
    // 🔧 TODO: 從 URL 取得 session_id,呼叫後端確認付款狀態
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get('session_id');
    
    if (sessionId) {
      console.log('Stripe Session ID:', sessionId);
      // 呼叫後端 API 更新訂閱狀態
    }
  }, []);

  return (
    <div className="min-h-screen min-h-[100dvh] bg-[#0a0a0c] flex items-center justify-center p-6">
      <div className="grain-overlay" />
      <div className="vignette" />

      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.8 }}
        className="relative z-10 text-center max-w-md"
      >
        {/* 成功圖示 */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: 'spring', stiffness: 200 }}
          className="w-24 h-24 mx-auto mb-8 rounded-full bg-gradient-to-br from-amber-500 to-amber-700 flex items-center justify-center shadow-[0_0_40px_rgba(245,158,11,0.4)]"
        >
          <SafeIcon icon={FiCheckCircle} className="text-5xl text-white" />
        </motion.div>

        {/* 標題 */}
        <h1 className="text-3xl md:text-4xl font-serif text-amber-400 tracking-widest mb-4">
          升級成功!
        </h1>
        <p className="text-gray-500 text-sm tracking-wider mb-8">
          Payment Successful
        </p>

        {/* 訊息 */}
        <div className="bg-white/5 border border-white/10 rounded-2xl p-6 backdrop-blur-md mb-8">
          <p className="text-gray-300 text-sm leading-relaxed tracking-wide">
            感謝你選擇支持未眠酒吧!<br />
            你的訂閱已生效,現在可以享受完整的深夜陪伴服務了。
          </p>
        </div>

        {/* 按鈕 */}
        <div className="flex flex-col space-y-4">
          <button
            onClick={() => navigate('/bar')}
            className="w-full bg-amber-500 text-black py-4 rounded-xl text-sm tracking-widest hover:bg-amber-400 transition-all flex items-center justify-center space-x-2"
          >
            <span>開始使用</span>
            <SafeIcon icon={FiArrowRight} />
          </button>
          <button
            onClick={() => navigate('/profile')}
            className="w-full bg-white/5 border border-white/10 text-gray-400 py-4 rounded-xl text-sm tracking-widest hover:bg-white/10 transition-all"
          >
            查看訂閱詳情
          </button>
        </div>

        {/* 提示 */}
        <p className="text-gray-600 text-xs mt-8 tracking-wider">
          你將在 Email 收到付款確認信
        </p>
      </motion.div>
    </div>
  );
}